import { Link } from "@tanstack/react-router";

import Button from "../form/Button";
import Modal from "../layout/Modal";

import { useInsufficientBalanceStore } from "@/stores/insufficientBalance.store";

export function InsufficientBalanceModal() {
  const { isOpen, close } = useInsufficientBalanceStore();

  return (
    <Modal
      isOpen={isOpen}
      setIsOpen={(v) => { if (!v) close(); }}
      title="Brak wystarczających środków"
    >
      <p className="text-secondary mb-6">
        Do generowania wymagane jest minimum 5$ na koncie. Doładuj konto, aby
        kontynuować.
      </p>

      <div className="grid grid-cols-2 gap-3">
        <Button variant="secondary" onClick={close}>
          Anuluj
        </Button>
        <Link to="/billing" search={{}} onClick={close} className="shrink-0">
          <Button>Doładuj konto</Button>
        </Link>
      </div>
    </Modal>
  );
}
